import React from 'react';
import PropTypes from 'prop-types';

import { Navigate, useParams, generatePath } from 'react-router-dom';
import { buildTeamPath } from 'utils/teamFromUrl';

export default function Redirect({ to, from }) {
  const params = useParams();
  const { teamKey } = params;
  // `to` is a route template (e.g. /service_events/:appointmentId). Substitute
  // the matched route params so dynamic segments aren't forwarded literally.
  const resolved = generatePath(to, params);
  const resolvedTo = teamKey ? buildTeamPath(teamKey, resolved) : resolved;
  return <Navigate to={resolvedTo} state={{ from }} replace />;
}

Redirect.propTypes = {
  to: PropTypes.string.isRequired,
  from: PropTypes.string,
};

Redirect.defaultProps = {
  from: undefined,
};
